module.exports = __webpack_public_path__ + "static/media/pdlogo.7cfe8b26.png";